import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { TIER_ORDER, TIER_META } from "../../lib/tiers";
import { useTripTypes } from "../../lib/tripTypes";

const empty = { title: "", location: "", description: "", image_url: "", includes: "", nights: 7, active: true, category: "vacation", tier: "domestic", premium_only: false, trip_type: "weekend", country: "United States", states: "" };

export const VacationForm = ({ open, onOpenChange, initial, onSave }) => {
  const tripTypes = useTripTypes();
  const [f, setF] = useState(empty);
  useEffect(() => {
    setF(initial ? { ...empty, ...initial, includes: initial.includes.join(", "), states: (initial.states || []).join(", ") } : empty);
  }, [initial, open]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const submit = (e) => {
    e.preventDefault();
    const { id, times_awarded, created_at, votes, ...rest } = f;
    onSave({ ...rest, states: f.country === "United States" ? String(f.states || "").split(",").map((x) => x.trim()).filter(Boolean) : [], nights: Number(f.nights), includes: f.includes.split(",").map((s) => s.trim()).filter(Boolean) });
  };
  const input = (k, label, props = {}) => (
    <label className="block"><span className="text-xs text-slate-400">{label}</span>
      <input data-testid={`vac-form-${k}`} value={f[k]} onChange={set(k)} className="lux-input mt-1" {...props} /></label>
  );
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#13192B] border-white/10 text-slate-100 max-h-[90vh] overflow-y-auto" data-testid="vacation-form-dialog">
        <DialogHeader><DialogTitle className="font-serif-lux text-3xl font-medium">{initial ? "Edit vacation" : "Add vacation"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          {input("title", "Title", { required: true })}
          {input("location", "Location", { required: true })}
          <label className="block"><span className="text-xs text-slate-400">Line</span>
            <select data-testid="vac-form-tier" value={f.tier} onChange={set("tier")} className="lux-input mt-1">
              {TIER_ORDER.map((t) => <option key={t} value={t}>{TIER_META[t].short}</option>)}
            </select></label>
          <label className="block"><span className="text-xs text-slate-400">Category</span>
            <select data-testid="vac-form-category" value={f.category} onChange={set("category")} className="lux-input mt-1">
              <option value="vacation">Vacation</option><option value="concert">Concert</option><option value="experience">Experience</option>
            </select></label>
          {input("nights", "Nights", { type: "number", min: 1 })}
          {input("image_url", "Image URL")}
          {input("includes", "Includes (comma separated)")}
          <label className="block"><span className="text-xs text-slate-400">Description</span>
            <textarea data-testid="vac-form-description" value={f.description} onChange={set("description")} rows={3} className="lux-input mt-1" /></label>
          <div className="grid grid-cols-2 gap-3">
            <label className="block"><span className="text-xs text-slate-400">Country</span>
              <input data-testid="vac-form-country" value={f.country} onChange={set("country")} className="lux-input mt-1" /></label>
            <label className="block"><span className="text-xs text-slate-400">US states (codes, e.g. CO, UT)</span>
              <input data-testid="vac-form-states" value={f.states} onChange={set("states")} disabled={f.country !== "United States"} className="lux-input mt-1 disabled:opacity-40" /></label>
          </div>
          <label className="block"><span className="text-xs text-slate-400">Trip type (booking window)</span>
            <select data-testid="vac-form-trip-type" value={f.trip_type} onChange={set("trip_type")} className="lux-input mt-1">
              {Object.entries(tripTypes).map(([k, t]) => <option key={k} value={k}>{`${t.label} · ${t.min}–${t.max} mo`}</option>)}
            </select></label>
          <label className="flex items-center gap-2 text-sm"><input data-testid="vac-form-premium" type="checkbox" checked={!!f.premium_only} onChange={set("premium_only")} /> Premium members only</label>
          <label className="flex items-center gap-2 text-sm"><input data-testid="vac-form-active" type="checkbox" checked={f.active} onChange={set("active")} /> Visible & eligible for awards</label>
          <button data-testid="vac-form-submit" className="btn-gold w-full py-3">Save</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
